module.exports = __webpack_public_path__ + "img/ic30Star.809f151a.svg";